import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import moment from "moment";
import { AppService } from "src/app/core/services/app.service";
import { FocusdataService } from "src/app/core/services/focusdata.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { LocalDataStoreService } from "src/app/core/services/local-data-store.service";
import { SalesSummary } from "src/app/shared/models/focusDataModels/SalesSummary";
import { ManagerLogCommentItem } from "src/app/shared/models/ManagerLogComment.item";
import { ManagerLogPostItem } from "src/app/shared/models/ManagerLogPost.item";
import { User } from "src/app/shared/models/user.model";

@Component({
	selector: "app-log-viewer",
	templateUrl: "./log-viewer.component.html",
	styleUrls: ["../../../../commandcenter.scss"],
})
export class LogViewerComponent implements OnInit, OnDestroy {
	@Input() managerLogPostSelected: ManagerLogPostItem;
	@Output() clearEmitter = new EventEmitter<boolean>();
	@Output() completedLogEmitter = new EventEmitter<ManagerLogPostItem>();

	commentsLoaded: boolean = false;
	currentUser: User;

	maxDate = moment().toDate();
	moment = moment;

	newComment: boolean = false;

	newLogPost: boolean = false;
	notifyUsers;

	salesSummary: SalesSummary;

	venueUserList: User[];

	constructor(
		public app: AppService,
		private focusdata: FocusdataService,
		private focuslink: FocuslinkService,
		private localStorage: LocalDataStoreService
	) {}

	ngOnInit() {
		this.init();
	}

	ngOnDestroy() {}

	async init() {
		this.currentUser = await this.localStorage.get("user");
		if (!this.managerLogPostSelected.businessDate) {
			this.newLogPost = true;
		}
		await this.usersForVenue();
		if (!this.venueUserList.some((i) => i.key === this.currentUser.key)) {
			this.venueUserList.push(this.currentUser);
		}
		await this.managerLogCommentGet();
	}

	async managerLogCommentGet() {
		const resp = await this.focuslink.managerLogGetOne(+this.managerLogPostSelected.pk.replace("LOG_", ""), this.managerLogPostSelected.sk);
		this.managerLogPostSelected = new ManagerLogPostItem(resp);
		if (this.managerLogPostSelected.managerLogComments && this.managerLogPostSelected.managerLogComments.length > 0) {
			this.managerLogPostSelected.managerLogComments.forEach((comment) => {
				comment.authorUser = this.venueUserList.find((i) => i.key === comment.authorUserKey) || undefined;
				comment.saved = true;
			});
		}
		this.commentsLoaded = true;
	}

	newCommentReturn(rec: ManagerLogCommentItem) {
		this.newComment = false;
		let existing = this.managerLogPostSelected.managerLogComments.find((i) => i.sk === rec.sk);
		existing = rec;
	}

	async usersForVenue() {
		const resp = await this.focuslink.usersForVenue(+this.managerLogPostSelected.pk.replace("LOG_", ""));
		this.venueUserList = resp.map((i) => new User(i));
		if (this.managerLogPostSelected.notifications && this.managerLogPostSelected.notifications.length > 0) {
			this.managerLogPostSelected.notificationUsers = this.venueUserList.filter((i) => this.managerLogPostSelected.notifications.includes(i.key));
		}
	}

	async savePost() {
		this.app.confirmation.confirm({
			message: `Are you sure you want to submit this log post?`,
			accept: async () => {
				this.focuslink.managerLogPost(+this.managerLogPostSelected.pk.replace("LOG_", ""), this.managerLogPostSelected);
				this.managerLogPostSelected.authorUser = this.currentUser;
				this.completedLogEmitter.emit(this.managerLogPostSelected);
				this.clearEmitter.emit(true);
			},
			reject: async () => {
				this.app.confirmation.close();
			},
		});
	}

	async salesSummaryGet(event) {
		try {
			const resp = await this.focusdata.salesSummary(+this.managerLogPostSelected.pk.replace("LOG_", ""), moment(event).format("MMDDYYYY"));
			this.salesSummary = new SalesSummary(resp);
			this.managerLogPostSelected.salesSummary = this.salesSummary;
		} catch (error) {
			this.salesSummary = new SalesSummary();
			this.managerLogPostSelected.salesSummary = new SalesSummary();
		}
	}
}
